import React from "react"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"

interface Props {
     isExtracting: boolean
     onDrop: (files: FileList | null) => void
}

/**
 * Step 1 — File upload zone for the consultant's prestation invoice (facture).
 * Supports drag & drop and click-to-browse.
 * Shows an extraction progress state while the AI is running.
 */
const StepUploadFacture = ({ isExtracting, onDrop }: Props) => {
     const inputRef = React.useRef<HTMLInputElement>(null)
     const [isDragging, setIsDragging] = React.useState(false)

     if (isExtracting) {
          return (
               <div className="py-12 text-center bg-light-primary border border-primary border-dashed rounded-3">
                    <MySimpleSpinner size="xl" />
                    <h5 className="fw-bold text-primary mt-5 mb-2">Analyse de la facture en cours...</h5>
                    <p className="text-gray-500 fs-7 mb-0">Extraction automatique du HT, TVA, frais et jours travaillés.</p>
               </div>
          )
     }

     return (
          <div
               className={`rounded-3 border-2 border-dashed p-10 text-center ${isDragging ? "border-primary bg-light-primary" : "border-gray-300 bg-light"}`}
               style={{ cursor: "pointer", transition: "all 0.2s" }}
               onClick={() => inputRef.current?.click()}
               onDragOver={e => {
                    e.preventDefault()
                    setIsDragging(true)
               }}
               onDragLeave={() => setIsDragging(false)}
               onDrop={e => {
                    e.preventDefault()
                    setIsDragging(false)
                    onDrop(e.dataTransfer.files)
               }}
          >
               <input ref={inputRef} type="file" accept="application/pdf,image/*" className="d-none" onChange={e => onDrop(e.target.files)} />
               <i className="fas fa-file-invoice fs-3x text-primary mb-5" />
               <h5 className="fw-bold mb-2">Déposez la facture de prestation (sans les justificatifs de frais)</h5>
               <p className="text-gray-500 fs-7 mb-0">PDF ou image — les montants HT, TVA et les jours travaillés seront extraits automatiquement.</p>
          </div>
     )
}

export default StepUploadFacture
